import { render, staticRenderFns } from "./admin-create-employer.vue?vue&type=template&id=2035600a&scoped=true"
import script from "./admin-create-employer.vue?vue&type=script&lang=js"
export * from "./admin-create-employer.vue?vue&type=script&lang=js"
import style0 from "./admin-create-employer.vue?vue&type=style&index=0&id=2035600a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2035600a",
  null
  
)

export default component.exports